import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import DataRow from '../DataRow';
import { calculateBlueskyScorePercentage, SCORE_TYPE } from '../../utils/helper';
import styles from './BlueSkySummary.module.scss';

const showValue = value => value !== null && value !== undefined && value !== '' ? value : 'N/A';

const BlueSkySummary = ({ className, data }) => {
    const [mobileView, setMobileView] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            // Check browser width and toggle columns accordingly
            if (window.innerWidth < 768) {
                setMobileView(true);
            } else {
                setMobileView(false);
            }
        };

        // Initial setup
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup  
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const scoreInPercentage = `${calculateBlueskyScorePercentage(data?.blueskyScoreIn, data?.blueskyScoreOut, SCORE_TYPE.IN)}%`;
    const scoreOutPercentage = `${calculateBlueskyScorePercentage(data?.blueskyScoreIn, data?.blueskyScoreOut, SCORE_TYPE.OUT)}%`;

    const formatValue = (count, percentage) => {
        const displayCount = showValue(count);

        if (displayCount === 'N/A' || !percentage) {
            return displayCount;
        }
        return `${displayCount} (${percentage})`;
    };

    return <>
        <div className={`${[styles.container]} ${className}`}>
            <div className={styles.titleSection}>
                <Typography gutterBottom variant='h4'>
                    Summary
                </Typography>
            </div>
            <Divider size='large' color='green' />
            <div className={!mobileView ? styles.dataRows : ''}>
                <DataRow title='Jurisdictions in Compliance' value={formatValue(data?.inCompliance, scoreInPercentage)} mobileView={mobileView} />
                <DataRow title='Jurisdictions out of Compliance' value={formatValue(data?.outOfCompliance, scoreOutPercentage)} mobileView={mobileView} />
            </div>
        </div>
    </>;
};

BlueSkySummary.propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({
        inCompliance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        outOfCompliance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        blueskyScoreIn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        blueskyScoreOut: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
};

export default BlueSkySummary;